
document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('customRegisterForm');
  const box  = document.getElementById('register-messages');
  const errors = document.querySelector('.errors');
  const STORAGE_KEY = 'register_success_intent';
  
  const hasIntent = sessionStorage.getItem(STORAGE_KEY) === '1';
  if (hasIntent) {
    sessionStorage.removeItem(STORAGE_KEY);
  }
  if (!form || !box) return;

  form.addEventListener('submit', () => {
    sessionStorage.setItem(STORAGE_KEY, '1');
  });

  if (hasIntent && !errors) {
    sessionStorage.removeItem(STORAGE_KEY);
   form.classList.add('hidden');
    box.classList.remove('hidden');
    box.classList.add('form__message--success');
    box.innerHTML = `
      <div>
      <p>Thanks for letting us fuel your office.</p>
        <p>Along the way let us know if we can answer any of your questions. You can always email us at <a href="mailto:info@thinkcoffee.com">info@thinkcoffee.com</a></p>
        <p class="flyer-account-wrap"><a href="/account"class="flyer-account-btn">Login</a></p>
      </div>
      <div class="flyer-details">
      <p>*Your discount will be auto applied in cart.</p>
      <p>**Please make sure you are logged in to your account to have the discount applied.</p>
      </div>
    `;
  }
});
